export default {
  // Navigation
  nav_home: 'Trang chủ',
  nav_dashboard: 'Bảng điều khiển',
  nav_orders: 'Đơn hàng',
  nav_wallet: 'Ví',
  nav_analytics: 'Phân tích',
  nav_referral: 'Giới thiệu',
  nav_account: 'Tài khoản',
  nav_notifications: 'Thông báo',
  nav_logout: 'Đăng xuất',
  nav_login: 'Đăng nhập',
  nav_signup: 'Đăng ký',
  nav_deposit_requests: 'Yêu cầu nạp tiền',
  nav_withdraw_requests: 'Yêu cầu rút tiền',
  support_btn_send: 'Gửi phản hồi',
  support_edit_message: 'Chỉnh sửa tin nhắn',
  support_delete_message: 'Xóa tin nhắn',
  support_delete_confirm: 'Bạn có chắc chắn muốn xóa tin nhắn này không?',
  support_message_updated: 'Tin nhắn đã được cập nhật thành công',
  support_message_deleted: 'Tin nhắn đã được xóa thành công',
  support_err_already_read: 'Không thể chỉnh sửa tin nhắn sau khi nó đã được xem.',
  nav_support_ticket: 'Vé hỗ trợ',
  nav_system_logs: 'Nhật ký hệ thống',
  nav_announcements: 'Thông báo',
  nav_activity_logs: 'Nhật ký hoạt động',
  nav_settings: 'Cài đặt',
  nav_section_main: 'Chính',
  nav_user_active: 'Đang hoạt động',
  nav_more: 'Thêm',
  nav_logout_confirm: 'Bạn có chắc chắn muốn đăng xuất?',
  nav_language: 'Ngôn ngữ',

  // Dashboard
  dashboard_welcome: 'Chào mừng quay trở lại',
  dashboard_total_earnings: 'Tổng thu nhập',
  dashboard_pending_orders: 'Đơn hàng chờ xử lý',
  dashboard_completed_orders: 'Đơn hàng đã hoàn thành',
  dashboard_commission_rate: 'Tỷ lệ hoa hồng',
  dashboard_quick_actions: 'Thao tác nhanh',
  dashboard_recent_orders: 'Đơn hàng gần đây',
  dashboard_recent_activity: 'Hoạt động gần đây',
  dashboard_wallet_balance: 'Số dư ví',
  dashboard_deposit: 'Nạp tiền',
  dashboard_withdraw: 'Rút tiền',
  dashboard_view_all: 'Xem tất cả',
  greeting_morning: 'Chào buổi sáng',
  greeting_afternoon: 'Chào buổi chiều',
  greeting_evening: 'Chào buổi tối',
  dashboard_greeting_desc: 'Theo dõi thu nhập, hoàn thành đơn hàng và quản lý tài khoản của bạn tại một nơi duy nhất. Hành trình thành công của bạn tiếp tục tại đây!',

  // Dashboard Stats
  stats_available_balance: 'Số dư khả dụng',
  stats_total_withdrawn: 'Tổng đã rút',
  stats_total_deposit: 'Tổng đã nạp',
  stats_pending_orders: 'Đơn chờ xử lý',
  stats_orders_suffix: ' đơn hàng',
  stats_task_earnings: 'Thu nhập nhiệm vụ',
  stats_lifetime_earning: 'Thu nhập trọn đời',

  // Orders
  orders_title: 'Đơn hàng của tôi',
  orders_all: 'Tất cả đơn hàng',
  orders_pending: 'Chờ xử lý',
  orders_completed: 'Đã hoàn thành',
  orders_cancelled: 'Đã hủy',
  orders_order_id: 'ID đơn hàng',
  orders_platform: 'Nền tảng',
  orders_amount: 'Số tiền',
  orders_commission: 'Hoa hồng',
  orders_status: 'Trạng thái',
  orders_date: 'Ngày',
  orders_no_orders: 'Không tìm thấy đơn hàng',
  orders_step_1: 'Xem xét chi tiết sản phẩm',
  orders_step_2: 'Xác minh thông tin đơn hàng',
  orders_step_3: 'Kết nối với nền tảng',
  orders_step_4: 'Gửi quảng bá',
  orders_step_5: 'Lập chỉ mục SEO',
  orders_step_6: 'Tăng cường hiển thị',
  orders_step_7: 'Hoàn tất và xác nhận',
  orders_btn_optimize: 'Tối ưu hóa đơn hàng',
  orders_btn_claim_commission: 'Nhận hoa hồng',
  orders_btn_task_completed: 'Nhiệm vụ hoàn thành',
  orders_price_label: 'Giá đơn hàng',
  orders_commission_rate_label: 'Tỷ lệ hoa hồng',

  // Wallet
  wallet_title: 'Ví của tôi',
  wallet_available_balance: 'Số dư khả dụng',
  wallet_pending_balance: 'Số dư chờ xử lý',
  wallet_total_withdrawn: 'Tổng đã rút',
  wallet_deposit_now: 'Nạp tiền ngay',
  wallet_withdraw_now: 'Rút tiền ngay',
  wallet_transaction_history: 'Lịch sử giao dịch',
  wallet_deposit_history: "Deposit History",
  wallet_withdrawal_history: 'Lịch sử rút tiền',
  wallet_deposit_desc: "Thêm tiền vào ví của bạn bằng các phương thức thanh toán có sẵn.",
  wallet_no_deposits: "Không tìm thấy khoản nạp tiền.",
  wallet_withdraw_history: "Lịch sử rút tiền",
  wallet_withdraw_desc: "Rút tiền từ ví của bạn.",
  wallet_no_withdrawals: "Không tìm thấy khoản rút tiền.",
  wallet_no_withdrawals_desc: "Bạn vẫn chưa thực hiện rút tiền nào.",
  withdrawal_restricted_title: 'Rút tiền bị hạn chế',
  withdrawal_restricted_message: 'Hiện tại bạn không thể rút tiền cho tài khoản của mình. Vui lòng liên hệ với bộ phận hỗ trợ khách hàng để biết thêm thông tin.',

  // Analytics
  analytics_title: 'Phân tích',
  analytics_earnings_overview: 'Tổng quan thu nhập',
  analytics_platform_breakdown: 'Phân tích nền tảng',
  analytics_performance_metrics: 'Chỉ số hiệu suất',
  analytics_top_products: 'Sản phẩm hàng đầu',
  analytics_this_month: 'Tháng này',
  analytics_last_month: 'Tháng trước',
  analytics_total_revenue: 'Tổng doanh thu',
  analytics_avg_order_value: 'Giá trị đơn hàng trung bình',

  // Referral
  referral_title: 'Chương trình giới thiệu',
  referral_your_code: 'Mã giới thiệu của bạn',
  referral_copy_code: 'Sao chép mã',
  referral_share_link: 'Chia sẻ liên kết',
  referral_total_referrals: 'Tổng giới thiệu',
  referral_active_referrals: 'Giới thiệu đang hoạt động',
  referral_referral_earnings: 'Thu nhập giới thiệu',
  referral_invite_friends: 'Mời bạn bè',

  // Account
  account_title: 'Cài đặt tài khoản',
  account_profile: 'Hồ sơ',
  account_security: 'Bảo mật',
  account_notifications: 'Thông báo',
  account_kyc: 'Xác minh KYC',
  account_phone: 'Số điện thoại',
  account_two_factor: 'Xác thực 2 yếu tố',
  account_save_changes: 'Lưu thay đổi',
  account_cancel: 'Hủy',

  // Auth & Common
  auth_email: 'Email',
  auth_password: 'Mật khẩu',
  auth_confirm_password: 'Xác nhận mật khẩu',
  auth_forgot_password: 'Quên mật khẩu?',
  auth_remember_me: 'Ghi nhớ đăng nhập',
  auth_login_button: 'Đăng nhập',
  auth_signup_button: 'Đăng ký',
  auth_already_have_account: 'Đã có tài khoản?',
  auth_dont_have_account: "Chưa có tài khoản?",
  auth_reset_password: 'Đặt lại mật khẩu',
  auth_verify_email: 'Xác minh Email',
  auth_live_platform: 'Nền tảng trực tiếp',
  auth_security_verification: 'Xác minh bảo mật',
  auth_captcha_refresh: 'Làm mới',
  auth_captcha_placeholder: 'Kết quả',
  auth_captcha_error: 'Tổng sai, vui lòng thử lại',
  auth_branding_title: 'Biến quảng cáo thành',
  auth_branding_highlight_prefix: '',
  auth_branding_highlight: 'Thu nhập thực tế',
  auth_branding_desc: 'Tham gia cùng hàng ngàn cộng tác viên đang kiếm hoa hồng hàng ngày từ các thương hiệu thương mại điện tử hàng đầu thế giới.',
  auth_sign_in_to_account: 'Đăng nhập vào tài khoản {{system_name}} của bạn',
  auth_email_placeholder: 'you@example.com',
  auth_password_placeholder: 'Nhập mật khẩu',
  auth_signing_in: 'Đang đăng nhập...',
  auth_free_to_join: 'Tham gia miễn phí',
  auth_signup_branding_title: 'Bắt đầu kiếm tiền',
  auth_signup_branding_highlight: 'Từ ngày đầu tiên',
  auth_signup_branding_desc: 'Không yêu cầu kinh nghiệm. Đăng ký trong 2 phút và bắt đầu hoàn thành nhiệm vụ cho các thương hiệu thương mại điện tử lớn.',
  auth_how_it_works: 'Cách hoạt động',
  auth_signup_desc: 'Tham gia {{system_name}} và bắt đầu kiếm hoa hồng ngay hôm nay — hoàn toàn miễn phí!',
  auth_step_1: 'Tạo tài khoản miễn phí',
  auth_step_2: 'Tìm và nhận nhiệm vụ',
  auth_step_3: 'Hoàn thành và nhận hoa hồng',
  auth_signup_step_1_title: 'Tạo tài khoản',
  auth_signup_step_1_desc: 'Bắt đầu hành trình của bạn',
  auth_signup_step_2_title: 'Hoàn thành nhiệm vụ',
  auth_signup_step_2_desc: 'Nhận hoa hồng hàng ngày',
  auth_signup_step_3_title: 'Rút tiền',
  auth_signup_step_3_desc: 'Thanh toán nhanh chóng & bảo mật',
  auth_benefit_1_title: 'An toàn & Tin cậy',
  auth_benefit_1_desc: 'Bảo mật cấp ngân hàng cho thu nhập của bạn',
  auth_benefit_2_title: 'Thanh toán tức thì',
  auth_benefit_2_desc: 'Rút thu nhập trong vòng 24 giờ',
  auth_benefit_3_title: 'Cộng đồng toàn cầu',
  auth_benefit_3_desc: 'Tham gia cùng 12.000+ cộng tác viên năng động',
  auth_benefit_4_title: 'Hỗ trợ 24/7',
  auth_benefit_4_desc: 'Nhận trợ giúp bất cứ khi nào bạn cần',
  auth_strength_weak: 'Yếu',
  auth_strength_fair: 'Trung bình',
  auth_strength_good: 'Tốt',
  auth_strength_strong: 'Mạnh',
  auth_password_strength: 'Độ mạnh mật khẩu: {{strength}}',
  auth_social_proof: 'Tham gia cùng {{count}}+ người đang kiếm tiền',
  auth_passwords_match: 'Mật khẩu khớp',
  auth_creating_account: 'Đang tạo tài khoản...',
  auth_phone_number: 'Số điện thoại',
  auth_phone_optional: '(Tùy chọn)',
  auth_phone_placeholder: 'Số điện thoại của bạn',
  auth_full_name: 'Họ và tên',
  auth_full_name_placeholder: 'Nguyễn Văn A',
  auth_password_min_chars: 'Tối thiểu 8 ký tự',
  auth_password_uppercase: 'Một chữ hoa (A-Z)',
  auth_password_lowercase: 'Một chữ thường (a-z)',
  auth_password_number: 'Một chữ số (0-9)',
  auth_password_special: 'Một ký tự đặc biệt (!@#$%^& v.v.)',
  auth_confirm_password_placeholder: 'Nhập lại mật khẩu',
  auth_agree_to: 'Tôi đồng ý với',
  auth_terms_of_service: 'Điều khoản dịch vụ',
  auth_privacy_policy: 'Chính sách bảo mật',
  auth_and: 'và',
  auth_create_free_account: 'Tạo tài khoản miễn phí',

  common_loading: 'Đang tải...',
  common_save: 'Lưu',
  common_cancel: 'Hủy',
  common_delete: 'Xóa',
  common_edit: 'Chỉnh sửa',
  common_view: 'Xem',
  common_search: 'Tìm kiếm',
  common_filter: 'Lọc',
  common_export: 'Xuất',
  common_import: 'Nhập',
  common_submit: 'Gửi',
  common_close: 'Đóng',
  common_confirm: 'Xác nhận',
  common_success: 'Thành công',
  common_error: 'Lỗi',
  common_warning: 'Cảnh báo',
  common_announcement: 'Thông báo',

  val_full_name_required: 'Họ tên là bắt buộc',
  val_email_required: 'Email là bắt buộc',
  val_password_required: 'Mật khẩu là bắt buộc',
  val_password_min: 'Mật khẩu phải có ít nhất 8 ký tự',
  val_passwords_dont_match: 'Mật khẩu không khớp',
  val_agree_terms: 'Bạn phải đồng ý với các điều khoản',
  val_conn_error: 'Lỗi kết nối. V vui lòng thử lại.',

  // Homepage
  home_hero_title: 'Kiếm hoa hồng từ các nền tảng thương mại điện tử hàng đầu',
  home_hero_subtitle: 'Tham gia cùng hàng ngàn người dùng kiếm hoa hồng hàng ngày từ Walmart, eBay và AliExpress',
  home_get_started: 'Bắt đầu ngay',
  home_learn_more: 'Tìm hiểu thêm',
  home_how_it_works: 'Cách hoạt động',
  home_features: 'Tính năng',
  home_why_choose_us: 'Tại sao chọn chúng tôi',
  home_features_title: 'Tính năng mạnh mẽ',
  home_features_subtitle: 'Mọi thứ bạn cần để bắt đầu kiếm tiền trực tuyến. Được xây dựng vì thành công của bạn.',
  home_commission_tiers: 'Cấp độ hoa hồng',
  home_testimonials: 'Người dùng nói gì về chúng tôi',
  home_faq: 'Câu hỏi thường gặp',
  home_cta_title: 'Sẵn sàng để bắt đầu kiếm tiền?',
  home_cta_subtitle: 'Gia nhập cộng đồng của chúng tôi ngay hôm nay và bắt đầu kiếm hoa hồng',
  home_trusted_partner: 'Nền tảng đối tác tin cậy',
  home_secure_platform: 'Nền tảng bảo mật',
  home_instant_payouts: 'Thanh toán tức thì',
  home_active_users: 'Người dùng năng động',
  home_paid_out: 'Đã thanh toán',
  home_total_paid_out: 'Tổng tiền đã thanh toán',
  home_user_rating: 'Đánh giá người dùng',
  home_countries: 'Quốc gia',
  home_commission_badge: 'Tiềm năng thu nhập',
  home_commission_title: 'Tỷ lệ hoa hồng',
  home_commission_desc: 'Số dư cao hơn sẽ mở khóa tỷ lệ hoa hồng tốt hơn. Mỗi phiên chỉ định chính xác 25 đơn hàng — hoàn thành tối đa 4 phiên mỗi ngày để tối đa hóa thu nhập.',
  home_tier_popular: 'Phổ biến nhất',
  home_tier_commission_per_order: 'Hoa hồng mỗi đơn hàng',
  home_tier_earn_examples: 'Ví dụ thu nhập:',
  home_tier_order: 'đơn hàng',
  home_tier_batch_earn: 'Thu nhập mỗi đợt 25 đơn:',
  home_tier_daily_potential: 'Tiềm năng hàng ngày (4 đợt × 25 đơn)',
  home_tier_max_daily: 'Lên đến 100 đơn hàng mỗi ngày',
  home_tier_benefit_1: '25 đơn hàng mỗi đợt',
  home_tier_benefit_2: 'Tối đa 4 đợt mỗi ngày',
  home_tier_benefit_3: 'Cộng hoa hồng tức thì',
  home_tier_above: 'Trên',
  home_tier_no_tiers: 'Không tìm thấy cấp độ hoa hồng nào.',

  // Comparison Section
  home_compare_badge: 'Sự khác biệt',
  home_compare_title: 'Tại sao chúng tôi tốt hơn',
  home_compare_subtitle: 'So sánh nền tảng của chúng tôi với các công việc bán thời gian truyền thống và xem tại sao hàng ngàn người chọn chúng tôi.',
  home_compare_feature: 'Tính năng',
  home_compare_traditional: 'Công việc truyền thống',
  home_compare_our_platform: 'Nền tảng của chúng tôi',
  home_compare_f1: 'Linh hoạt',
  home_compare_f1_trad: 'Giờ giấc cố định',
  home_compare_f1_our: 'Làm việc mọi lúc, mọi nơi',
  home_compare_f2: 'Thanh toán',
  home_compare_f2_trad: 'Hàng tháng hoặc 2 tuần/lần',
  home_compare_f2_our: 'Tức thì / Trong ngày',
  home_compare_f3: 'Yêu cầu',
  home_compare_f3_trad: 'Kinh nghiệm/CV/Phỏng vấn',
  home_compare_f3_our: 'Không yêu cầu - Chỉ cần smartphone',
  home_compare_f4: 'Tăng trưởng',
  home_compare_f4_trad: 'Tăng lương hàng năm cố định',
  home_compare_f4_our: 'Tăng trưởng không giới hạn theo cấp độ',

  // Testimonials
  home_testi_badge: 'Câu chuyện thành công',
  home_testi_title: 'Được hàng ngàn người tin dùng',
  home_testi_subtitle: 'Lắng nghe từ cộng đồng cộng tác viên toàn cầu của chúng tôi, những người đã thay đổi thu nhập của họ.',
  home_testi_no_stories: 'Chưa có câu chuyện thành công nào.',
  home_testi_total_earned: 'Tổng thu nhập',
  home_testi_time_period: 'Khoảng thời gian',
  home_testi_verified: 'Người dùng đã xác minh',
  home_testi_avg_rating: 'Đánh giá trung bình',
  home_testi_satisfaction_rate: 'Tỷ lệ hài lòng',
  home_testi_support_available: 'Hỗ trợ sẵn sàng',

  // FAQ
  home_faq_badge: 'Hỗ trợ',
  home_faq_title: 'Câu hỏi thường gặp',
  home_faq_subtitle: 'Mọi thứ bạn cần biết về cách bắt đầu và kiếm tiền.',
  home_faq_no_data: 'Không tìm thấy câu hỏi nào.',

  // Trust Bar
  home_trust_badge: 'Tin cậy toàn cầu',
  home_trust_title: 'Được các thương hiệu hàng đầu tin dùng',
  home_trust_desc: 'Chúng tôi hợp tác với các nền tảng thương mại điện tử lớn nhất thế giới để cung cấp các dịch vụ quảng bá đã được xác minh.',

  // Feature Section
  feature_1_title: 'Thanh toán tức thì',
  feature_1_desc: 'Nhận thu nhập của bạn được cộng ngay sau khi hoàn thành đơn hàng. Rút tiền bất cứ lúc nào không chậm trễ.',
  feature_1_detail_1: 'Cộng hoa hồng thời gian thực',
  feature_1_detail_2: 'Nhiều tùy chọn rút tiền',
  feature_1_detail_3: 'Không có ngưỡng tối thiểu',
  feature_2_title: 'Nền tảng bảo mật',
  feature_2_desc: 'Mã hóa cấp ngân hàng bảo vệ dữ liệu và thu nhập của bạn. Được hàng ngàn người dùng trên thế giới tin tưởng.',
  feature_2_detail_1: 'Đã bật mã hóa SSL',
  feature_2_detail_2: 'Xác thực 2 yếu tố',
  feature_2_detail_3: 'Kiểm tra bảo mật định kỳ',
  feature_2_detail_4: 'Đảm bảo quyền riêng tư dữ liệu',
  feature_3_title: 'Giờ giấc linh hoạt',
  feature_3_desc: 'Làm việc bất cứ khi nào bạn muốn, bất cứ nơi đâu. Hoàn thành đơn hàng theo tốc độ của riêng bạn, không có lịch trình cố định.',
  feature_3_detail_1: 'Không có giờ làm việc cố định',
  feature_3_detail_2: 'Làm việc từ bất cứ đâu',
  feature_3_detail_3: 'Tự chọn tốc độ làm việc',
  feature_3_detail_4: 'Hoạt động cả cuối tuần',
  feature_4_title: 'Thu nhập lũy tiến',
  feature_4_desc: 'Mở khóa tỷ lệ hoa hồng cao hơn khi bạn hoàn thành nhiều đơn hàng hơn. Tăng thu nhập sau mỗi lần nâng cấp.',
  feature_4_detail_1: 'Tỷ lệ hoa hồng theo cấp độ',
  feature_4_detail_2: 'Nâng cấp tự động',
  feature_4_detail_3: 'Thưởng hiệu suất',
  feature_5_title: 'Nền tảng toàn cầu',
  feature_5_desc: 'Làm việc với các thương hiệu quốc tế từ mọi nơi trên thế giới. Bao gồm hỗ trợ đa tiền tệ.',
  feature_5_detail_1: 'Có mặt trên toàn thế giới',
  feature_5_detail_2: 'Hỗ trợ đa tiền tệ',
  feature_5_detail_3: 'Phương thức thanh toán địa phương',
  feature_6_title: 'Hỗ trợ 24/7',
  feature_6_desc: 'Đội ngũ hỗ trợ tận tâm của chúng tôi luôn sẵn sàng giúp đỡ. Nhận trợ giúp qua chat trực tiếp, email hoặc điện thoại.',
  feature_6_detail_1: 'Chat trực tiếp có sẵn',
  feature_6_detail_2: 'Hỗ trợ email 24/7',
  feature_6_detail_3: 'Hỗ trợ qua điện thoại',
  feature_6_detail_4: 'Câu hỏi thường gặp đầy đủ',
  feature_7_title: 'Chương trình giới thiệu',
  feature_7_desc: 'Kiếm thêm thu nhập bằng cách mời bạn bè. Nhận hoa hồng trọn đời từ thu nhập của những người bạn giới thiệu.',
  feature_7_detail_1: 'Thu nhập giới thiệu trọn đời',
  feature_7_detail_2: 'Giới thiệu không giới hạn',
  feature_7_detail_3: 'Công cụ chia sẻ dễ dàng',
  feature_7_detail_4: 'Phần thưởng khuyến khích',
  feature_8_title: 'Đa tiền tệ',
  feature_8_desc: 'Hỗ trợ các loại tiền tệ chính và phương thức thanh toán. Chọn phương thức phù hợp nhất với bạn.',
  feature_8_detail_1: 'Hỗ trợ USD, EUR, GBP',
  feature_8_detail_2: 'Chuyển khoản ngân hàng có sẵn',
  feature_8_detail_3: 'Tích hợp ví điện tử',
  feature_8_detail_4: 'Tùy chọn tiền điện tử sắp ra mắt',
  feature_9_title: 'Thông báo tức thì',
  feature_9_desc: 'Luôn cập nhật các cảnh báo thời gian thực về đơn hàng mới, thu nhập và hoạt động tài khoản.',
  feature_9_detail_1: 'Thông báo đẩy',
  feature_9_detail_2: 'Cảnh báo qua email',
  feature_9_detail_3: 'Cập nhật SMS',
  feature_9_detail_4: 'Tin nhắn trong ứng dụng',

  // Home Page Additional Sections
  home_how_it_works_badge: 'Quy trình đơn giản',
  home_how_it_works_title: 'Cách hoạt động',
  home_how_it_works_subtitle: 'Bắt đầu kiếm tiền chỉ với 4 bước đơn giản. Không yêu cầu kinh nghiệm, chỉ cần làm theo quy trình và theo dõi thu nhập của bạn tăng trưởng.',
  home_cta_ready_title: 'Sẵn sàng bắt đầu hành trình của bạn?',
  home_cta_ready_desc: 'Tham gia cùng hàng ngàn người dùng đang kiếm tiền hàng ngày. Khoản hoa hồng đầu tiên của bạn chỉ cách vài phút!',
  home_cta_avg_time: 'Thời gian trung bình cho thu nhập đầu tiên:',
  home_cta_15_mins: '15 phút',
  home_cta_new_users: 'Người dùng mới trong hôm nay:',

  // CTA Section (Premium)
  home_cta_limit_spots: 'Số lượng đăng ký có hạn trong tháng này',
  home_cta_main_title: 'Bắt đầu kiếm tiền',
  home_cta_today: 'Ngay hôm nay!',
  home_cta_main_desc: 'Tham gia cùng hàng ngàn người dùng đang kiếm hoa hồng hàng ngày. Không cần kinh nghiệm, giờ giấc linh hoạt, thanh toán tức thì. Tự do tài chính của bạn bắt đầu từ đây.',
  home_cta_spots_remaining: 'Số chỗ còn lại',
  home_cta_new_users_today: 'Người dùng mới hôm nay',
  home_cta_create_account: 'Tạo tài khoản miễn phí',
  home_cta_sign_in: 'Đăng nhập',
  home_cta_secure: 'Bảo mật 100%',
  home_cta_payouts: 'Rút tiền trong 24-48h',
  home_cta_rating: 'Đánh giá 4.9/5',
  home_cta_active_users: 'Người dùng năng động',
  home_cta_total_paid: 'Tổng đã chi trả',
  home_cta_orders_done: 'Nhiệm vụ đã hoàn thành',
  home_cta_satisfaction: 'Mức độ hài lòng',
  home_cta_guarantee_title: 'Đảm bảo hoàn tiền',
  home_cta_guarantee_desc: 'Không hài lòng? Nhận lại khoản nạp của bạn trong vòng 7 ngày',

  // Footer Branding & Extras
  footer_brand_desc: 'Nền tảng quảng bá thương mại điện tử hàng đầu thế giới. Gia nhập mạng lưới cộng tác viên toàn cầu của chúng tôi ngay hôm nay và bắt đầu kiếm hoa hồng từ các thương hiệu lớn.',
  footer_ssl_secure: 'Bảo mật SSL',
  footer_aes_256: 'Mã hóa AES-256',
  footer_cookie_policy: 'Chính sách Cookie',
  footer_disclaimer: 'Tuyên bố từ chối trách nhiệm',
  footer_all_rights: 'Bảo lưu mọi quyền.',

  // Announcements
  announcement_withdrawal_delay_title: 'Chậm trễ trong việc xử lý rút tiền',
  announcement_withdrawal_delay_summary: 'Việc rút tiền có thể mất tới 72 giờ do khối lượng yêu cầu lớn. Vui lòng lập kế hoạch phù hợp.',
  announcement_date_june_14: 'Ngày 14 tháng 6 năm 2025',

  // How It Works Steps
  step_1_title: 'Đăng ký',
  step_1_desc: 'Mất chưa đầy 2 phút để tạo tài khoản của bạn.',
  step_1_detail_1: 'Nhập thông tin cơ bản của bạn',
  step_1_detail_2: 'Xác minh địa chỉ email',
  step_1_detail_3: 'Bảo mật tài khoản của bạn',
  step_1_detail_4: 'Truy cập bảng điều khiển tức thì',
  step_2_title: 'Chọn nhiệm vụ',
  step_2_desc: 'Chọn từ các nhiệm vụ quảng bá có sẵn.',
  step_2_detail_1: 'Lọc theo nền tảng',
  step_2_detail_2: 'Xem tỷ lệ hoa hồng',
  step_2_detail_3: 'Chấp nhận nhiều nhiệm vụ',
  step_2_detail_4: 'Cập nhật nhiệm vụ theo thời gian thực',
  step_3_title: 'Hoàn thành nhiệm vụ',
  step_3_desc: 'Hoàn thành nhiệm vụ theo hướng dẫn.',
  step_3_detail_1: 'Hướng dẫn dễ thực hiện',
  step_3_detail_2: 'Gửi nhiệm vụ nhanh chóng',
  step_3_detail_3: 'Tự động kiểm tra xác minh',
  step_3_detail_4: 'Giao diện thân thiện với di động',
  step_4_title: 'Kiếm tiền & Rút tiền',
  step_4_desc: 'Được thanh toán cho mỗi nhiệm vụ hoàn thành.',
  step_4_detail_1: 'Theo dõi thu nhập thời gian thực',
  step_4_detail_2: 'Ngưỡng rút tiền cực thấp',
  step_4_detail_3: 'Nhiều phương thức thanh toán',
  step_4_detail_4: 'Hỗ trợ rút tiền 24/7',

  // Redesigned Footer
  footer_stay_loop_title: 'Luôn cập nhật',
  footer_stay_loop_desc: 'Nhận các cập nhật, mẹo và ưu đãi độc quyền mới nhất trực tiếp vào hộp thư đến của bạn.',
  footer_subscribe: 'Đăng ký',
  footer_subscribe_placeholder: 'Nhập địa chỉ email của bạn',
  footer_trusted_secure: 'ĐÁNG TIN CẬY & AN TOÀN:',
  footer_ssl_secured: 'Bảo mật SSL',
  footer_ssl_secured_desc: 'SSL 256-bit',
  footer_aes_encryption: 'Mã hóa AES-256',
  footer_aes_encryption_desc: 'Cấp ngân hàng',
  footer_kyc_compliant: 'Tuân thủ KYC',
  footer_kyc_compliant_desc: 'Đã xác minh',
  footer_gdpr_compliant: 'Tuân thủ GDPR',
  footer_gdpr_compliant_desc: 'Dữ liệu được bảo vệ',
  footer_iso_certified: 'ISO 27001',
  footer_iso_certified_desc: 'Đã chứng nhận',
  footer_platform: 'NỀN TẢNG',
  footer_support: 'HỖ TRỢ',
  footer_legal: 'PHÁP LÝ',
  footer_help_center: 'Trung tâm trợ giúp',
  footer_contact_us: 'Liên hệ với chúng tôi',
  footer_payments_label: 'Thanh toán:',
  home_live_activity_title: 'Hoạt động nền tảng trực tiếp',
  home_recent_activity_title: 'Hoạt động gần đây',
  home_total_commissions_paid: 'Tổng hoa hồng đã trả',
  home_active_users_online: 'Người dùng đang hoạt động',
  home_tasks_completed_today: 'Nhiệm vụ đã hoàn thành hôm nay',
  security_fill_all: 'Vui lòng điền vào tất cả các trường.',
  security_match_err: 'Mật khẩu không khớp.',
  security_pin_6_err: 'Mã PIN phải có đúng 6 chữ số.',
  security_pin_digit_err: 'Mã PIN chỉ được chứa các chữ số.',
  security_placeholder_pin_dots: '......',
  security_pw_current: 'Mật khẩu Hiện tại',
  account_security_tips_title: 'Khuyến nghị Bảo mật',
  account_security_tips_desc: 'Cải thiện khả năng bảo vệ tài khoản của bạn bằng cách tuân theo các phương pháp hay nhất đơn giản này.',
  tip_password_title: 'Mật khẩu Mạnh',
  tip_password_desc: 'Sử dụng kết hợp các chữ cái, số và ký hiệu để đảm bảo tài khoản của bạn luôn an toàn.',
  tip_two_factor_title: 'Xác minh Danh tính',
  tip_two_factor_desc: 'Luôn cập nhật thông tin liên hệ của bạn để nhận các thông báo bảo mật quan trọng.',
  tip_logout_title: 'Đăng xuất Thường xuyên',
  tip_logout_desc: 'Luôn đăng xuất khỏi tài khoản của bạn khi sử dụng máy tính công cộng hoặc máy tính dùng chung.',
  tip_sharing_title: 'Không bao giờ Chia sẻ Truy cập',
  tip_sharing_desc: 'Nhóm hỗ trợ của chúng tôi sẽ không bao giờ hỏi mật khẩu của bạn. Không bao giờ chia sẻ thông tin đăng nhập của bạn với bất kỳ ai.',

  // Yêu cầu đơn hàng
  order_requests_title: 'Yêu cầu đơn hàng',
  order_requests_desc: 'Gửi yêu cầu cho một nhiệm vụ mới hoặc đơn hàng tùy chỉnh. Quản trị viên sẽ xem xét và chỉ định nhiệm vụ dựa trên yêu cầu của bạn.',
  order_requests_new_btn: 'Yêu cầu đơn hàng mới',
  order_requests_table_id: 'ID yêu cầu',
  order_requests_table_data: 'Chi tiết yêu cầu',
  order_requests_table_status: 'Trạng thái',
  order_requests_table_date: 'Đã gửi lúc',
  order_requests_table_actions: 'Hành động',
  order_requests_cancel: 'Hủy',
  order_requests_cancel_confirm: 'Bạn có chắc chắn muốn hủy yêu cầu đơn hàng này không?',
  order_requests_cancel_success: 'Hủy yêu cầu đơn hàng thành công.',
  order_requests_create_success: 'Gửi yêu cầu đơn hàng thành công.',
  order_requests_modal_title: 'Gửi yêu cầu đơn hàng mới',
  order_requests_modal_desc: 'Vui lòng cung cấp thông tin chi tiết về đơn hàng bạn muốn yêu cầu.',
  order_requests_field_data: 'Dữ liệu yêu cầu đơn hàng',
  order_requests_field_placeholder: 'vd: Tôi muốn yêu cầu một đơn hàng tùy chỉnh cho Gói Cao cấp.',
  order_requests_btn_submit: 'Gửi yêu cầu',
  order_requests_btn_submitting: 'Đang gửi...',
  order_requests_empty: 'Không tìm thấy yêu cầu đơn hàng nào.',
  order_requests_status_pending: 'Đang chờ xử lý',
  order_requests_status_approved: 'Đã phê duyệt',
  order_requests_status_rejected: 'Đã từ chối',
  order_requests_status_cancelled: 'Đã hủy',
  order_requests_terms_title: 'Điều khoản Đặt hàng Ràng buộc',
  order_requests_term_1: 'Các đơn hàng mới sẽ được phân bổ trong vòng 24–48 giờ sau khi được phê duyệt.',
  order_requests_term_2: 'Sau khi được phát hành, các đơn hàng không thể bị hủy, tạm dừng hoặc sửa đổi.',
  order_requests_term_3: 'Tất cả các đơn hàng được chỉ định phải được hoàn thành trước khi rút tiền.',
  order_requests_term_4: 'Việc không hoàn thành các đơn hàng có thể ảnh hưởng đến trạng thái tài khoản của bạn.',
  order_requests_term_5: 'Yêu cầu này là cuối cùng và không thể đảo ngược sau khi gửi.',
  order_requests_policy_title: 'Chính sách Không Hủy bỏ',
  order_requests_policy_desc: 'Bằng cách gửi yêu cầu này, bạn xác nhận rằng đợt đặt hàng mới là không thể hủy bỏ. Sau khi được hệ thống của chúng tôi xác nhận, không có việc hủy bỏ, sửa đổi hoặc hoàn tiền nào được phép trong bất kỳ trường hợp nào.',
  order_requests_accept_terms: 'Tôi đã đọc và hiểu đầy đủ các điều khoản trên. Tôi xác nhận rằng một khi đã gửi, yêu cầu đặt hàng này không thể bị hủy hoặc sửa đổi, và tôi đồng ý hoàn thành tất cả các đơn hàng được chỉ định.',

  // Orders Page (New Sections)
  orders_withdrawal_policy: 'Chính sách Rút tiền',
  orders_unlock_req: 'Yêu cầu Mở khóa',
  orders_unlock_desc: 'Hoàn thành đợt đầu tiên gồm {{count}} đơn hàng để mở khóa tính năng rút tiền vĩnh viễn. Yêu cầu một lần này đảm bảo tính toàn vẹn của nền tảng và ngăn chặn sự lạm dụng.',
  orders_daily_limits: 'Giới hạn Đơn hàng Hàng ngày',
  orders_daily_limit_1: '{{count}} đơn hàng mỗi đợt — bạn phải hoàn thành tất cả trước khi yêu cầu đợt tiếp theo',
  orders_daily_limit_2: 'Tối đa {{count}} đợt mỗi ngày (tổng cộng {{total}} đơn hàng/ngày)',
  orders_comm_rates: 'Tỷ lệ Hoa hồng',
  orders_comm_rates_desc: 'Tỷ lệ được xác định bởi nền tảng và số dư ví hiện tại của bạn:',
  orders_payout_timeline: 'Thời gian Thanh toán',
  orders_payout_desc: 'Các yêu cầu rút tiền được xử lý trong vòng 24-48 giờ. Chuyển khoản ngân hàng có thể mất 3-5 ngày làm việc. Rút tiền điện tử là tức thì.',
  orders_processing_fee: 'Phí xử lý {{fee}}% được áp dụng cho tất cả các khoản rút tiền để bù đắp chi phí giao dịch.',
  orders_tips_title: 'Mẹo để Thành công',
  orders_tips_1: 'Hoàn thành đơn hàng hàng ngày để tạo đà và tối đa hóa thu nhập của bạn',
  orders_tips_2: 'Hãy ở lại trang trong khi xử lý để đảm bảo hoàn thành đúng cách',
  orders_tips_3: 'Kiểm tra ví của bạn thường xuyên để theo dõi sự tăng trưởng của hoa hồng',
  orders_tips_4: 'Giới thiệu bạn bè để nhận hoa hồng thưởng từ đơn hàng của họ',
  orders_tips_5: 'Liên hệ với bộ phận hỗ trợ ngay lập tức nếu bạn gặp bất kỳ vấn đề nào',
  orders_batch_approx: '{{count}} đơn hàng/đợt × trung bình ${{avg}} = khoảng ${{total}} mỗi đợt',

  // Settings
  settings_page_title: 'Cài đặt',
  settings_page_desc: 'Quản lý bảo mật, quyền riêng tư và sở thích của bạn',
  settings_kyc_label: 'Xác minh KYC',
  settings_kyc_desc: 'Xác minh danh tính',
  settings_security_label: 'Bảo mật',
  settings_security_desc: 'Quản lý mật khẩu',
  settings_language_label: 'Ngôn ngữ',
  settings_language_desc: 'Tùy chọn vùng',
  // Modal nạp tiền
  deposit_modal_title_method: "Chọn phương thức thanh toán",
  deposit_modal_title_gateway: "Chọn ví tiền điện tử",
  deposit_modal_title_plan: "Chọn gói nạp tiền",
  deposit_modal_title_details: "Chi tiết nạp tiền",
  deposit_modal_step_method: "Phương thức",
  deposit_modal_step_gateway: "Ví",
  deposit_modal_step_plan: "Gói",
  deposit_modal_step_details: "Chi tiết",
  deposit_modal_credit_card: "Thẻ tín dụng / Thẻ ghi nợ",
  deposit_modal_bank_transfer: "Chuyển khoản ngân hàng",
  deposit_modal_ewallet: "Ví điện tử",
  deposit_modal_digital_currency: "Tiền kỹ thuật số",
  deposit_modal_not_available: "Không khả dụng tại khu vực của bạn",
  deposit_modal_available_recommended: "Khả dụng — Được đề xuất",
  deposit_modal_back_to_method: "Quay lại phương thức thanh toán",
  deposit_modal_back_to_gateway: "Quay lại danh sách ví",
  deposit_modal_back_to_plan: "Quay lại gói nạp",
  deposit_modal_digital_selected: "Đã chọn tiền kỹ thuật số",
  deposit_modal_digital_hint: "Chọn ví tiền điện tử của bạn để nhận địa chỉ và hướng dẫn.",
  deposit_modal_loading_wallets: "Đang tải ví...",
  deposit_modal_no_wallets: "Không có ví tiền điện tử nào khả dụng.",
  deposit_modal_loading_plans: "Đang tải gói...",
  deposit_modal_no_plans: "Hiện không có gói nạp tiền nào khả dụng.",
  deposit_modal_duration: "Thời gian",
  deposit_modal_amounts_profits: "Số tiền & Lợi nhuận",
  deposit_modal_amount_label: "Số tiền",
  deposit_modal_profit_label: "Lợi nhuận",
  deposit_modal_benefits: "Lợi ích",
  deposit_modal_continue: "Tiếp tục",
  deposit_modal_transfer_details: "Chi tiết chuyển khoản cho {{name}}",
  deposit_modal_deposit_amount: "Số tiền nạp",
  deposit_modal_amount_fixed: "Số tiền được cố định theo gói bạn đã chọn",
  deposit_modal_txn_id: "ID giao dịch",
  deposit_modal_txn_optional: "(Tùy chọn)",
  deposit_modal_txn_placeholder: "vd: 0x1a2b3c4d...",
  deposit_modal_screenshot: "Ảnh chụp màn hình",
  deposit_modal_upload_proof: "Tải lên bằng chứng thanh toán",
  deposit_modal_upload_hint: "PNG, JPG, JPEG — Tối đa 5MB",
  deposit_modal_comments: "Ghi chú",
  deposit_modal_comments_placeholder: "Bất kỳ thông tin bổ sung nào...",
  deposit_modal_notice: "Sau khi gửi, đội ngũ của chúng tôi sẽ xác minh khoản thanh toán của bạn và cộng tiền vào tài khoản trong vòng 5-30 phút.",
  deposit_modal_confirm: "Xác nhận nạp tiền",
  deposit_modal_submitting: "Đang gửi...",
  deposit_modal_err_fields: "Vui lòng điền đầy đủ các thông tin bắt buộc",
  deposit_modal_err_submit: "Đã xảy ra lỗi trong quá trình gửi",
  deposit_modal_success: "Yêu cầu nạp tiền thành công!",
  deposit_modal_err_plans: "Không thể tải các gói nạp tiền",
  deposit_modal_err_wallets: "Không thể tải các phương thức thanh toán",
  deposit_modal_new_to_crypto: "New to crypto? Learn how to buy digital currency",
  deposit_modal_crypto_label: "Tiền điện tử",
  orders_insufficient_balance: "Insufficient Balance",
  orders_balance_gap_msg1: "Your current balance is not enough to complete this order.",
  orders_balance_gap_msg2_start: "Please add",
  orders_balance_gap_msg2_end: "to proceed and unlock your commission.",
  orders_btn_add_funds: "Add Funds",
  withdrawal_restricted_support: "Contact Support",
  deposit_modal_plan_description_hint: "Add the deposit for getting the order and earn the commission from order process",
};
